import React from "react";
import { render } from 'storyblok-rich-text-react-renderer';
import "./index.css"
import rteResolver from "../../../utils/rteResolver";

const CopyBlock = (props) => {

 

    const blok = props.blok;
    return (
        <section className="width py-8 lg:py-12">
            <div className="max-w-[57.563rem] mx-auto rte text-lg unpad-first unpad-last">
                {render(blok.copy, rteResolver)}
            </div>
        </section>
    )
}

export default CopyBlock;